import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import Layout from './Layout';

const metaOverrideSet = buildFacetDesignOverride()
  .done();

const RoadmapChartStepTemplate = ({ resource }) => {
  return (
    <MetaResourceRenderer
      layout={Layout}
      resource={resource}
      metaOverrideSet={metaOverrideSet}
    />
  );
};

RoadmapChartStepTemplate.defaultProps = {
};

RoadmapChartStepTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default RoadmapChartStepTemplate;
